"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconArrowLeft = void 0;
var React = __importStar(require("react"));
var IconArrowLeft = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M8.4998,19.9998 C8.3778,19.9998 8.2548,19.9548 8.1588,19.8648 C7.9568,19.6768 7.9458,19.3598 8.1348,19.1588 L14.8158,11.9998 L8.1348,4.8408 C7.9458,4.6398 7.9568,4.3228 8.1588,4.1348 C8.3588,3.9458 8.6768,3.9568 8.8648,4.1588 L15.8648,11.6588 C16.0448,11.8508 16.0448,12.1488 15.8648,12.3408 L8.8648,19.8408 C8.7668,19.9458 8.6338,19.9998 8.4998,19.9998", transform: "matrix(-1 0 0 1 24 0)" }))); };
exports.IconArrowLeft = IconArrowLeft;
exports.IconArrowLeft.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconArrowLeft;
